import { render } from "./ParamCarrierPageList.vue?vue&type=template&id=b9755c12&scoped=true&ts=true"
import script from "./ParamCarrierPageList.vue?vue&type=script&lang=ts"
export * from "./ParamCarrierPageList.vue?vue&type=script&lang=ts"

import "./ParamCarrierPageList.vue?vue&type=style&index=0&id=b9755c12&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9755c12"]])

export default __exports__